module.exports = __webpack_public_path__ + "static/bcorp-417f6b13315f0d8ea9d85a779c6c2d75.svg";